import { tryLoadLightDOMStyles } from '../../Global/loadDependency'
import { getNavPortalMenuStyles } from './NavPortalMenu.styles'
import type {} from './types/NavPortalMenu.type'

const t = document.createElement('template')
t.innerHTML = `
  <nav class="nav-portal-menu" role="navigation" aria-label="Application Navigation">
    <slot></slot>
  </nav>
`
const TemplateNavPortalMenu = t

class NavPortalMenu extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getNavPortalMenuStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavPortalMenu.content.cloneNode(true))
    tryLoadLightDOMStyles('NavPortalMenu.css')
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('NavPortalMenu connectedCallback')
  }
}

if (!customElements.get('ts-navportal-menu')) {
  customElements.define('ts-navportal-menu', NavPortalMenu)
}
export { NavPortalMenu }
